import { render } from "./Product.vue?vue&type=template&id=200cf2c2&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"

import "./Product.vue?vue&type=style&index=0&id=200cf2c2&lang=css"
import "./Product.vue?vue&type=style&index=1&id=200cf2c2&scoped=true&lang=css"

import exportComponent from "E:\\zzh\\zl-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-200cf2c2"]])

export default __exports__